module.exports = __webpack_public_path__ + "static/media/compress.36811b18.svg";